import moment from 'moment'
import React,{useState,useEffect,useRef} from 'react'
import { User,Role,FR } from '../../sdk'
import { Loader } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'
import { toasterFunction } from '../Default/ToasterComponent'
import { assetUrl } from '../../helpers'

export const MainContent=()=> {
  const [state,setState]=useState({loader:true,date:moment().format("yyyy-MM-DD"),actualData:[],data:[],
  tbHeader:[{title:"#",name:"count"},{title:"Name",name:"name"},{title:"Email",name:"user_email"},{title:"Password",name:"user_password"},{title:"Role",name:"role"},{title:"Image",name:"role"},{title:"Operations",name:"operations"}],
  updated:false,
  tableLoader:false,
  buttonLoader:false,
  buttonDisabled:false,
  roles:[],
  count:1,
  imgPreview:"",
  imgPreview2:"",
  formAttr:{
   firstName:"",
   lastName:"",
    email:"",
    password:"",
    image:{},
    designation:"",
    userRole:"",
    isHightAuthority:0,
    companyName:"",
    departmentName:"",
  },
  updateFormAttr:{
    firstName:"",
    lastName:"",
    email:"",
    password:"",
    userRole:"",
    designation:"",
    id:0,
    index:0,
    image:{},
    isHightAuthority:0,
    companyName:"",
    departmentName:"",
    
  },
  companyName:"",
  department:"",
  companies:[],
  departments:[],
  });
  const ref=useRef();
  const ref2=useRef();
  const onHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="image"){
      oldState.imgPreview=URL.createObjectURL(event.target.files[0]);
      oldState.formAttr[key]=event.target.files[0];
    }
    else if(key==="isHightAuthority"){
      oldState.formAttr.isHightAuthority=oldState.formAttr.isHightAuthority==0?1:0;
      
    }
    else{
      oldState.formAttr[key]=value;
    }
     
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
  const onUpdateHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="image"){
      oldState.imgPreview2=URL.createObjectURL(event.target.files[0]);
      oldState.updateFormAttr[key]=event.target.files[0];
    }
    else if(key==="isHightAuthority"){
      oldState.updateFormAttr.isHightAuthority=oldState.updateFormAttr.isHightAuthority==0?1:0;
      
    }
    else{
      oldState.updateFormAttr[key]=value;
    }
     
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
  const apiData=async()=>{
    try{
    let roles=await new Role().get();
    let users=await new User().get();
    let companies=await new FR().getCompanies();
    let arr=[];
    let count=1;
    
     if(users.length){
     for(let val of users){
       let imgName;
       if(val.media.length){
        let check=val.media[0].media_url.split("/");
        if(check.length && check[check.length-1] !=="avatar.jpg"){
          imgName=val.media[0].media_url;
        }
       }
       arr.push([count,`${val.firstName} ${val.lastName}`,val.email,val.userPassword?val.userPassword:"",val?.userRole?.name??"",imgName?`<div id="" style="display: none;">${assetUrl}${imgName}</div><img src=${assetUrl}${imgName} style="width:100%;max-height:100px" />`:"no image",`<button type="button" class="btn btn-danger delete" data-index=${count} data-id=${val._id}><i class="fa fa-trash" aria-hidden="true"></i></button> <button type="button" class="btn btn-default update" data-index=${count} data-id=${val._id}><i class="fa fa-pencil" aria-hidden="true"></i></button>`])
       count++;
      }
    }
    setState((pre)=>{
      return {...pre,data:arr,loader:false,tableLoader:false,actualData:users,roles:roles,count,companies}
   })
   }catch(e){
    console.log(e)
    alert("error occur")
    }

}
const onDelete=async(id,index)=>{
try{
  if(window.confirm("are you want to delete this")){
    await new User().delete({id});
    let oldState={...state};
    toasterFunction.success("user has been deleted")
    window.location.reload()
    // oldState.data=oldState.data.filter(val=>Number(val[0]) !==Number(index));
    // oldState.actualData=oldState.actualData.filter(val=>Number(val.id) !==Number(id));
    // setState((pre)=>{
    //   return {...pre,...oldState}
    // })
  }
 
}catch(e){

}
}
const onUpdate=(id,index)=>{
let data=state.actualData.find(val=> val._id===id);
console.log(data)
 if(data){
  let oldState={...state};
  let imgName="";
  if(data.media.length){
   let check=data.media[0].media_url.split("/");
   if(check.length && check[check.length-1] !=="avatar.jpg"){
     imgName=`${assetUrl}${data.media[0].media_url}`;
   }
  }
  oldState.imgPreview2=imgName
  oldState.updateFormAttr={...oldState.updateFormAttr,email:data.email,firstName:data.firstName,lastName:data.lastName,userRole:data.userRole._id,id,index,isHightAuthority:data.isHightAuthority,companyName:data.companyName};
  window.$("#showEditForm").modal("show")
  setState((pre)=>{
    return {...pre,...oldState}
  })
 }
 else{
  alert("data not found")
 }
  
}
const modalHandler=(id=false)=>{
window.$("#showForm").modal("show")
}
const onSubmitAdd=async (event)=>{
  event.preventDefault();
  ref.current.disabled=true;
  ref.current.firstElementChild.style.display="inline-block"
 try{
await new User().add(state.formAttr);
toasterFunction.success("user has been added")
window.location.reload();
}catch(e){
 
if(e.response.status===300){
  toasterFunction.error("email already taken")
}
else{
  toasterFunction.error(e.response.data.message)
}

}finally{
  ref.current.disabled=false;
ref.current.firstElementChild.style.display="none"
}
}
const onSubmitUpdate=async (event)=>{
  event.preventDefault();
  ref2.current.disabled=true;
  ref2.current.firstElementChild.style.display="inline-block"
 
try{
await new User().update({...state.updateFormAttr});
toasterFunction.success("user has been updated");
window.location.reload();
}catch(e){
  console.log(e);
  if(e.response.status===300){
  toasterFunction.error("email already exist")
}
else{
  toasterFunction.error(e.response.data.message)
}

}finally{
  ref2.current.disabled=false;
ref2.current.firstElementChild.style.display="none"
}
}

useEffect(()=>{
apiData();
},[])
if(!state.loader){
  return (
    <>
      <div className="card mb-3">
       {/* BEGIN card-body */}
       <div className="card-body">
   <div className="col-12 mb-4">
     <div className="row" style={{textAlign:"center"}}>
       <div className="col-12">
       <div className="fw-bold mb-3">
   <span className="flex-grow-1 text-white">User</span>
   </div> 
       </div>
       <div className="col-10"></div>
       <div className="col-2" style={{textAlign:"end"}}>
       <button type="button" class="btn btn-theme" onClick={modalHandler}>Add new User</button>
       </div>
      
     </div>
  
   </div>
   {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
  <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated} parentFun={{onUpdate,onDelete}}/>
  
   </div>
   </div>
   <div className="card-arrow">
         <div className="card-arrow-top-left" />
         <div className="card-arrow-top-right" />
         <div className="card-arrow-bottom-left" />
         <div className="card-arrow-bottom-right" />
       </div>
   </div>
   
   <div class="modal" id="showForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add New User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitAdd}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
              name='firstName'
              value={state.formAttr.firstName}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
              name='lastName'
              value={state.formAttr.lastName}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Email
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter Email"
              name='email'
              value={state.formAttr.email}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Password
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter Password"
              name='password'
              value={state.formAttr.password}
              onChange={onHandler}
              minLength={4}
              required
            />
          </div>
        </div>
     
        <div className="col-xl-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label" for="exampleFormControlSelect1">Select Role</label>
                                    <select class="form-select" id="exampleFormControlSelect1" onChange={onHandler} name="userRole" required>
                                      <option value="">Select Role</option>
                                     {state.roles.map((v,index)=>{
                                          return (<>
                                          <option key={index} value={v._id} selected={v._id ===state.formAttr.userRole}>{v.name}</option>
                                          
                                          </>)
                                     })}
                                    </select>
                                  </div>
                                
                </div>
                <div className="col-xl-12">
                <div className="row">
                <div className="col-xl-6">
        <div class="mb-3">
														<label class="form-label" for="lgFile1">Image</label>
														<input type="file" class="form-control" id="lgFile1" name="image" onChange={onHandler} accept="image/*"/>
													</div>
        </div>
        <div className="col-xl-6"></div>
      {state.imgPreview !=="" && <>
        <div className="col-xl-6">
        <div class="mb-3">
													<img src={state.imgPreview} alt={state.imgPreview} style={{width:"100%",height: "135px"}}/>
													</div>
        </div>
      </>} 
                </div>
               </div>
                <div className="col-xl-12">
                  <div className="row">
                  <div className="col-xl-6" style={{marginTop:"2rem"}}>
          <div className="form-group mb-3" style={{display: "flex",
    justifyContent: "space-between",
    width: "25%"}}>
          <label className="form-label" htmlFor='checkBox1'>
              Is High Authority
            </label>
            <input
              id='checkBox1'
              type="checkbox"
              className="form-check-input"
              name='isHightAuthority'
              value={1}
              onChange={onHandler}
              checked={state.formAttr.isHightAuthority}
             />
          </div>
        </div>
        {!!state.formAttr.isHightAuthority && <>
          <div className="col-xl-6">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" >Select Company</label>
        <select class="form-select" name="companyName" id="exampleFormControlSelect1" onChange={onHandler} required>
          <option value="" selected={state.formAttr.companyName===""}>Default</option>
          {state.companies.map((val,index)=>{
            return  <option key={index} value={val.companyName} selected={state.formAttr.companyName===val.companyName}>{val.companyName}</option>
          })}
         
          
          </select>
          </div>
       </div>
        </>}
                  </div>
                </div>
               
     
             
              
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref} disabled={false}>Add <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div>
<div class="modal" id="showEditForm">
<div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitUpdate}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
              name='firstName'
              value={state.updateFormAttr.firstName}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
              name='lastName'
              value={state.updateFormAttr.firstName}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Email
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter Email"
              name='email'
              value={state.updateFormAttr.email}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Password
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter Password"
              name='password'
              value={state.updateFormAttr.password}
              onChange={onUpdateHandler}
              minLength={4}
              
            />
          </div>
        </div>
     
        <div className="col-xl-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label" for="exampleFormControlSelect1">Select Role</label>
                                    <select class="form-select" id="exampleFormControlSelect1" onChange={onUpdateHandler} name="userRole" required>
                                      <option value="">Select Role</option>
                                     {state.roles.map((v,index)=>{
                                          return (<>
                                          <option key={index} value={v._id} selected={v._id ===state.updateFormAttr.userRole}>{v.name}</option>
                                          
                                          </>)
                                     })}
                                    </select>
                                  </div>
                                
                </div>
                <div className="col-xl-12">
                <div className="row">
                <div className="col-xl-6">
        <div class="mb-3">
														<label class="form-label" for="lgFile1">Image</label>
														<input type="file" class="form-control" id="lgFile1" name="image" onChange={onUpdateHandler} accept="image/*"/>
													</div>
        </div>
        <div className="col-xl-6"></div>
      {state.imgPreview2 !=="" && <>
        <div className="col-xl-6">
        <div class="mb-3">
													<img src={state.imgPreview2} alt={state.imgPreview2} style={{width:"100%",height: "135px"}}/>
													</div>
        </div>
      </>} 
                </div>
               </div>
                <div className="col-xl-12">
                  <div className="row">
                  <div className="col-xl-6" style={{marginTop:"2rem"}}>
          <div className="form-group mb-3" style={{display: "flex",
    justifyContent: "space-between",
    width: "25%"}}>
          <label className="form-label" htmlFor='checkBox2'>
              Is High Authority
            </label>
            <input
              id='checkBox2'
              type="checkbox"
              className="form-check-input"
              name='isHightAuthority'
              value={1}
              onChange={onUpdateHandler}
              checked={state.updateFormAttr.isHightAuthority}
             />
          </div>
        </div>
        {!!state.updateFormAttr.isHightAuthority && <>
          <div className="col-xl-6">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" >Select Company</label>
        <select class="form-select" name="companyName" id="exampleFormControlSelect1" onChange={onUpdateHandler} required>
          <option value="" selected={state.updateFormAttr.companyName===""}>Default</option>
          {state.companies.map((val,index)=>{
            return  <option key={index} value={val.companyName} selected={state.updateFormAttr.companyName===val.companyName}>{val.companyName}</option>
          })}
         
          
          </select>
          </div>
       </div>
        </>}
                  </div>
                </div>
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref2} disabled={false}>Edit <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div>


 </>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}
